// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isEngagementIntelligentDeliveryPreviewResult = objectOf({
  time_per_channel: objectOf({
    email: objectOf({
      optimized: objectOf({
        "52200": number,
      }),
      unoptimized: objectOf({
        "61200": number,
      }),
    }),
  }),
  chart_start_unix: number,
});
